import store from '~/store';
import Constants from 'Helpers/constants';
import Vue from 'vue';

const mixinMethods = {
    methods: {
        onResize: function () {
            let slotTableTopHeight;

            if (this.isShowExtraFilters !== undefined) {
                slotTableTopHeight = this.isShowExtraFilters ? 104 : 52;
            } else {
                slotTableTopHeight = this.$refs.top ? this.$refs.top.clientHeight : 0;
            }

            let slotTableStatsHeight = this.$refs.stats ? this.$refs.stats.clientHeight : 0;

            let slotTableFooterHeight = document.getElementsByClassName('v-data-footer').length
                ? document.getElementsByClassName('v-data-footer')[0].clientHeight
                : 0;
            let menuHeight = document.getElementById('menu') ? document.getElementById('menu').clientHeight : 0;
            let notificationHeight =
                document.getElementById('notification') && this.$route.name !== 'notifications' ? document.getElementById('notification').clientHeight : 0;

            let mobileBetPanel = 0;
            if (this.panel && this.isMobile) {
                mobileBetPanel = 240;
            }

            this.tableHeight =
                this.$vuetify.breakpoint.height -
                4 - //loading
                slotTableTopHeight -
                slotTableStatsHeight -
                menuHeight -
                notificationHeight -
                slotTableFooterHeight -
                mobileBetPanel;
        },
        closeDatePicker: function () {
            if (this.filters.date.length === 2) {
                this.options.page = 1;
                let from = new Date(this.filters.date[0]);
                let to = new Date(this.filters.date[1]);
                if (from > to) {
                    this.filters.date = [this.filters.date[1], this.filters.date[0]];
                }
            } else if (this.filters.date[1] === undefined && this.filters.date[0] !== undefined) {
                this.filters.date = [this.filters.date[0], this.filters.date[0]];
            }

            this.menuDate = false;
            this.debouncedloadData();

            this.$nextTick(() => {
                this.onResize();
            });
        },
        rowClass: function (item) {
            return item.line === 1 ? 'btRowClass bbRowClass' : 'bbRowClass';
        },
        updateCurrentTime() {
            if (this.$refs.currentTime) {
                this.$refs.currentTime.innerText = Vue.filter('formatInTimeZone')(new Date(), 'HH:mm:ss', true);
            }
        },
        updateCurrentDate() {
            if (this.$refs.currentDate) {
                this.$refs.currentDate.innerText = Vue.filter('formatInTimeZone')(new Date(), 'EEEE, MMMM dd', true);
            }
        },
        getMarketCode: function (period_type_id) {
            let gamePeriods = this.getEventPeriodDictionary;
            let result = period_type_id ? gamePeriods.filter((gamePeriod) => gamePeriod.id === period_type_id) : null;

            return result ? result[0].code : null;
        },

        getMarketAbbr: function (item, withBetType = false) {
            let period = item.period_type_id === Constants.GAME_PERIOD_FT ? store.$i18n.t('order.periodFTAbbr') : store.$i18n.t('order.period1HAbbr');
            let betType = '';

            if (withBetType) {
                switch (item.type) {
                    case 'J':
                    case 'D':
                        betType = ' | ' + store.$i18n.t('order.handicapAbbr');
                        break;
                    case 'CJ':
                    case 'CD':
                        betType = ' | ' + store.$i18n.t('order.cornersHandicapAbbr');
                        break;
                    case 'O':
                    case 'U':
                        betType = ' | ' + store.$i18n.t('order.goalAbbr');
                        break;
                    case 'CO':
                    case 'CU':
                        betType = ' | ' + store.$i18n.t('order.cornersGoalAbbr');
                        break;
                    case '1':
                    case 'X':
                    case '2':
                        betType = ' | 1X2';
                        break;
                    case 'Y':
                    case 'N':
                        betType = ' | ' + store.$i18n.t('order.bts');
                        break;
                    case '1X':
                    case 'X2':
                    case '12':
                        betType = ' | ' + store.$i18n.t('panel.dc');
                        break;
                    case 'CS':
                        betType = ' | ' + store.$i18n.t('order.cs');
                        break;
                    default:
                        break;
                }
            }

            return (item.is_live ? store.$i18n.t('panel.marketLiveShort') : store.$i18n.t('panel.marketDballShort')) + ' | ' + period + betType;
        },

        getMarketFull: function (item, withBetType = false) {
            let period = item.period_type_id === Constants.GAME_PERIOD_FT ? store.$i18n.t('panel.marketFT') : store.$i18n.t('panel.market1H');
            let betType = '';

            if (withBetType) {
                switch (item.type) {
                    case 'J':
                    case 'D':
                        betType = ' | ' + store.$i18n.t('panel.asianHandicap');
                        break;
                    case 'CJ':
                    case 'CD':
                        betType = ' | ' + store.$i18n.t('panel.cornersAsianHandicap');
                        break;
                    case 'O':
                    case 'U':
                        betType = ' | ' + store.$i18n.t('panel.goal');
                        break;
                    case 'CO':
                    case 'CU':
                        betType = ' | ' + store.$i18n.t('panel.cornersGoal');
                        break;
                    case '1':
                    case 'X':
                    case '2':
                        betType = ' | ' + store.$i18n.t('panel.1X2');
                        break;
                    case 'Y':
                    case 'N':
                        betType = ' | ' + store.$i18n.t('panel.btts');
                        break;
                    case '1X':
                    case 'X2':
                    case '12':
                        betType = ' | ' + store.$i18n.t('panel.doubleChance');
                        break;
                    case 'CS':
                        betType = ' | ' + store.$i18n.t('order.correctScore');
                        break;
                    default:
                        break;
                }
            }
            return (item.is_live ? store.$i18n.t('panel.marketLive') : store.$i18n.t('panel.marketDball')) + ' | ' + period + betType;
        },
        setDate(type) {
            let date = new Date();
            let firstDay = new Date();
            let day;
            let diff;

            switch (type) {
                case 'today':
                    break;
                case 'week':
                    day = date.getDay();
                    diff = date.getDate() - day + (day === 0 ? -6 : 1);
                    firstDay = new Date(date.setDate(diff));
                    break;
                case 'month':
                    firstDay = new Date(date.getFullYear(), date.getMonth(), 1, date.getHours());
                    break;
                default:
                    this.filters.date = [firstDay.toISOString().slice(0, 10), new Date().toISOString().slice(0, 10)];
            }

            this.filters.date = [firstDay.toISOString().slice(0, 10), new Date().toISOString().slice(0, 10)];
            this.closeDatePicker();
        },
    },
};

export default mixinMethods;
